// extracted by mini-css-extract-plugin
module.exports = {"label":"SelectCorpYear_label__1wScQ","button":"SelectCorpYear_button__-TuBc"};